export enum DeviceStatus {
	ACTIVE = 'ACTIVE',
	MAINTENANCE = 'MAINTENANCE',
	CANCELLED = 'CANCELLED',
	BLOCKED = 'BLOCKED',
}

// Date & Time enums
export enum DisabledDates {
	WEEKENDS_ONLY = 'WEEKENDS_ONLY',
	ALL_PREVIOUS_DATES = 'ALL_PREVIOUS_DATES',
	ALL_BEFORE_TOMORROW = 'ALL_BEFORE_TOMORROW',
}

export enum TimeFormats {
	TIMESTAMP = 'h [hrs], m [min]',
	TIMESTAMP_SECONDS_HUMANIZED = 'h [hrs], m [min], s [sec]',
	TIMESTAMP_WITH_SECONDS = 'hh:mm:ss',
	TIMESTAMP_COUNTER = 'm [min], s [sec]',
}

export enum TripStatus {
	PENDING = 0,
	IN_PROGRESS = 1,
	COMPLETED = 2,
	INCOMPLETED = 3,
	CANCEL = 4,
}

export enum SendVerificationCodeMethod {
	SMS = 'SMS',
	EMAIL = 'EMAIL',
}
